<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col>
        <b-card>
          <div id="map"></div>
          <template v-if="showBack" slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
var marker;
export default {
  props: ["reportData"],
  data() {
    return {
      appLoading: false,
      totalCount: 0,
      report: null,
      map: null,
      showBack: false,
      ServerError: false
    };
  },
  beforeMount() {
    this.report = this.reportData;
    // console.log(this.report)
    if (window.location.pathname.substring(0, 5) == "/Map/")
      this.showBack = true;
  },
  mounted() {
    if (window.location.pathname.substring(0, 5) != "/Map/") this.loadMap();
    else this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/incident/get",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.report = response.data.data;
          this.loadMap();
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    loadMap() {
      var mapCanvas = document.getElementById("map");
      var mapOptions = {
        center: new google.maps.LatLng(
          this.report.location[1],
          this.report.location[0]
        ),
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.HYBRID
      };
      this.map = new google.maps.Map(mapCanvas, mapOptions);
      var latlngset = new google.maps.LatLng(
        this.report.location[1],
        this.report.location[0]
      );
      // var iconBase = {url: "http://naturesociety.leopardtechlabs.com/img/mapPin.png",
      //             scaledSize: new google.maps.Size(30, 40), // scaled size
      //             origin: new google.maps.Point(0, 0), // origin
      //             anchor: new google.maps.Point(0, 0), // anchor
      // };
      // var iconBase = "./../../assets/map/map_marker_red.png";
      var location = this.report.locationname;
      marker = new google.maps.Marker({
        map: this.map,
        position: latlngset,
        // icon: iconBase
      });
      this.oMarker = {
        m: marker,
        c: this.$route.params.id
      };
        var content =
          "<table align='center'><tr><td><b style='color:red;'>Location :&nbsp;</b>" +
          location +
         "</td></tr></table>";
        var infowindow = new google.maps.InfoWindow({
          maxWidth: 200
        });
        google.maps.event.addListener(
          marker,
          "click",
          (function(marker, content, infowindow) {
            return function() {
              infowindow.setContent(content);
              infowindow.open(this.map, marker);
            };
          })(marker, content, infowindow)
        );
    }
  }
};
</script>
<style scoped>
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>